import React from 'react'
import { Helmet } from 'react-helmet';
import { Link } from '@jota-ds/lib-react'
import Header from '../header'
import { One, Two, Three, Four, Five, Six } from '../sections'

export default function Home() {
	const [animate, setAnimate] = React.useState(null)

	React.useEffect(() => document.addEventListener('scroll', _handleScroll), [])

	const _handleScroll = event => {
		let animate = document.getElementById('animate')
		let position = document.body.getBoundingClientRect()
		let y = Math.abs(position.top)
		if(y > (window.innerHeight / 3)) {
			animate.classList.add("zoom-in")
		}else {
			animate.classList.remove("zoom-in")
		}
	}

	return (
		<>
			<Helmet defer={false}>
				{/* <!-- Primary Meta Tags --> */}
				<title>Bilhete Dourado Meiuca | Descontão nos nossos cursos</title>
				<meta name="title" content="Bilhete Dourado Meiuca | Descontão nos nossos cursos" />
				<meta name="description" content="Um programa de descontos para deixar qualquer Willy Wonka no chinelo." />

				{/* <!-- Open Graph / Facebook --> */}
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://bilhete.meiuca.co/" />
				<meta property="og:title" content="Bilhete Dourado Meiuca | Descontão nos nossos cursos" />
				<meta property="og:description" content="Um programa de descontos para deixar qualquer Willy Wonka no chinelo." />
				<meta property="og:image" content="https://bilhete-dourado.s3.amazonaws.com/assets/bilhete-dourado-descontos-cursos-meiuca.jpg" />

				{/* <!-- Twitter --> */}
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:url" content="https://bilhete.meiuca.co/" />
				<meta property="twitter:title" content="Bilhete Dourado Meiuca | Descontão nos nossos cursos" />
				<meta property="twitter:description" content="Um programa de descontos para deixar qualquer Willy Wonka no chinelo." />
				<meta property="twitter:image" content="https://bilhete-dourado.s3.amazonaws.com/assets/bilhete-dourado-descontos-cursos-meiuca.jpg" />
			</Helmet>

			<div className="scroll-animate">
				<Header />
				<One />
			</div>
			<Two />
			<Three />
			<Four />
			<Five />
			<Six />

			<footer className="footer">
                <div className="container-fluid">
                    <div className="ps-3 pe-3 ps-md-5 pe-md-5 d-flex">
                        <a href="/" rel="noopener noreferrer">
                            <img alt="" src="/assets/LogoFooter.svg" />
                        </a>

                        <div className="d-flex align-items-center ms-auto">
                            <strong className="me-3">© 2021 Meiuca</strong>
                            <a className="me-3 d-none d-md-block" href="https://lgpd.meiuca.co/" target="_blank" rel="noopener noreferrer">
								<Link
									label="Politíca de Privacidade"
								/>
							</a>
							<a href="https://lgpd.meiuca.co/" target="_blank" rel="noopener noreferrer">
								<Link
									label="Termos"
								/>
							</a>
                        </div>
                    </div>
                </div>
            </footer>
		</>
	)
}